import config from '../config';
import { ActionTypes as actions, ContextActions, NotificationsActions, ToastActions, PracticeActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import axios from 'axios';

const displayError = (message, data) => {
  return dispatch => {
    var errorMessage = '';
    if (data) {
      errorMessage = data.error && data.error.message ? data.error.message : '';
    }
    if (data && typeof data.error === 'string') {
      errorMessage = data.error;
    }
    if (data && typeof data.message === 'string') {
      errorMessage = data.message;
    }
    if (data && data.message && data.message.message) {
      errorMessage = data.message.message;
    }
    if (message) {
      errorMessage = message;
    }
    if (typeof errorMessage === 'string') {
      dispatch(ToastActions.displayError(errorMessage));
    }
  }
}

const signIn = (email, password, callback) => {
  return dispatch => {

    const encodedEmail = encodeURIComponent(email);

    const requestURL = `${config.BASE_URL}/login?email=${encodedEmail}&password=${password}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.get(requestURL, requestConfig).then((response) => {

      const data = response.data || {};
      let token = data.token || '';
      let user_id = data.user_id || '';

      if (data.success && token && user_id) {
        dispatch(getAuthenticatedUserInfo(token, user_id, true));
        if (callback) {
          callback(true, '');
        }
      } else {
        const errorMessage = data.error && data.error.message ? data.error.message : 'Login Error. Please ensure you are connected to the internet';
        if (callback) {
          callback(true, errorMessage);
        }
        if (data.error && data.error.message) {
          dispatch(ToastActions.displayError(data.error.message));
        }
      }

    }).catch((error) => { dispatch(displayError(error)); })

  }
}

const signOut = () => {
  return dispatch => {
    dispatch({
      type: actions.USER_SIGN_OUT
    })
  }
}

const determineInitialNavigation = () => {
  return (dispatch, getState) => {

    const state = getState();

    const practices = state.user.practices || {};
    const roles = state.user.roles || {};

    const allPracticeIDs = Object.keys(practices);

    const approvedPracticeIDs = allPracticeIDs.map((id) => {
      const roleForThisPractice = roles[id];
      if (roleForThisPractice && roleForThisPractice.approved === true) {
        return id;
      } else { return null }
    }).filter((id) => { return id });

    const onlyOneApprovedPractice = approvedPracticeIDs.length === 1 ? true : false;
    const practiceID = onlyOneApprovedPractice && approvedPracticeIDs[0] ? approvedPracticeIDs[0] : '';
    const userRoleForPractice = roles[practiceID];

    let user = state.user.user;

    if (user && user.is_veg) {
      history.push(routes.EMG);
      return;
    }

    if (onlyOneApprovedPractice && userRoleForPractice) {
      var totalRoles = { count: 0, lastTrue: ''};

      totalRoles = userRoleForPractice.admin            ?  { count: totalRoles.count + 1, lastTrue: 'admin'            } : totalRoles;
      totalRoles = userRoleForPractice.practice_manager ?  { count: totalRoles.count + 1, lastTrue: 'practice_manager' } : totalRoles;
      totalRoles = userRoleForPractice.practice_owner   ?  { count: totalRoles.count + 1, lastTrue: 'practice_owner'   } : totalRoles;
      totalRoles = userRoleForPractice.vet              ?  { count: totalRoles.count + 1, lastTrue: 'vet'              } : totalRoles;
      totalRoles = userRoleForPractice.behaviorist      ?  { count: totalRoles.count + 1, lastTrue: 'behaviorist'      } : totalRoles;
      totalRoles = userRoleForPractice.tech             ?  { count: totalRoles.count + 1, lastTrue: 'tech'             } : totalRoles;
      totalRoles = userRoleForPractice.front_desk       ?  { count: totalRoles.count + 1, lastTrue: 'front_desk'       } : totalRoles;

      if (totalRoles.count === 1) {
        const selectedPractice = practiceID;
        const selectedRole = totalRoles.lastTrue;
        dispatch({ type: actions.CONTEXT_UPDATE_PRACTICE, payload: selectedPractice })
        dispatch({ type: actions.CONTEXT_UPDATE_ROLE,     payload: selectedRole })
        dispatch(PracticeActions.getSelectedPractice(selectedPractice, true));
        dispatch(ContextActions.performNewPracticeTasks());
        // history.push(routes.HOME);
      } else {
        history.push(routes.SWITCH_ACCOUNTS);
        // history.push(routes.EMG);
      }
    } else {
      if (allPracticeIDs.length === 0 || Object.keys(roles).length === 0 || approvedPracticeIDs.length === 0) {
        history.push(routes.HOME);
      } else {
        history.push(routes.SWITCH_ACCOUNTS);
      }
    }
  }
}

const getUserRoles = (token, user_id, initialFetch) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/user_roles/${user_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const roles = data.roles || [];
      if (roles.length > 0) {
        roles.forEach((role, index) => {
          const practiceID = role.practice_id;
          dispatch(getPractice(practiceID, token, roles.length === index + 1 && initialFetch));
          dispatch({
            type: actions.USER_ADD_ROLE,
            payload: role
          })
        });
      } else {
        if (roles.length === 0) {
          dispatch({ type: actions.USER_UPDATE_ROLES, payload: {} })
        }
        if (initialFetch) {
          dispatch(determineInitialNavigation());
        }
      }

    }).catch((error) => { console.log(error) })

  }
}

const getPractice = (practiceID, token, runInitialNav) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/${practiceID}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const practice = data.data;
      if (practice) {
        dispatch({
          type: actions.USER_ADD_PRACTICE,
          payload: practice
        })
      }
      if (runInitialNav) {
        dispatch(determineInitialNavigation());
      }
    }).catch((error) => {
      if (runInitialNav) {
        dispatch(determineInitialNavigation());
      }
      console.log(error)
    })

  }
}

const authenticationSuccess = (token, user_id) => {
  return dispatch => {
    const authObject = {
      token: token,
      user_id: user_id,
    }

    dispatch({
      type: actions.USER_AUTH_UPDATE,
      payload: authObject
    })
  }
}

const getAuthenticatedUserInfo = (token, user_id, fromSignIn) => {

  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const user = data.data;
      if (user && user.type !== 'CLIENT') {

        if (fromSignIn) {
          dispatch(authenticationSuccess(token, user_id));
          dispatch(getUserRoles(token, user_id, true));
          dispatch(getUserPracticeLocations(token, user_id));
          dispatch(getUserNotificationPreferences(token, user_id));
          dispatch(NotificationsActions.requestBrowserNotificationPermissions());
          dispatch(NotificationsActions.subscribeToNotificationsSocket(user_id));
          dispatch(NotificationsActions.getUserUnreadNotifications(token));
        }

        dispatch({
          type: actions.USER_UPDATE_INFO,
          payload: user
        });
        dispatch({
          type: actions.USER_ADD_USER,
          payload: user
        });
      }
      if (user && user.type === 'CLIENT') {
        dispatch(ToastActions.displayError('The Web Portal is accessible to Provider accounts only. Clients can Sign In using the TeleTails mobile application on iOS or Android'));
      }
    }).catch((error) => { console.log(error) });

  }
}

const createAccount = (data) => {

  const userInfo = data.userInfo;
  const newPracticeInfo = data.newPracticeInfo;
  const existingPracticeInfo = data.existingPracticeInfo;
  const profilePicFormData = data.profilePicFormData;

  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    const requestURL = `${config.BASE_URL}/register`;
    const signInRequestURL = `${config.BASE_URL}/login?email=${userInfo.email}&password=${userInfo.password}`;

    axios.post(requestURL, JSON.stringify(userInfo), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        return axios.get(signInRequestURL, requestConfig);
      } else { console.log(data) }
    })
    .then((res) => {
      let token = res.data.token || '';
      let user_id = res.data.user_id || '';
      if (token && user_id) {
        dispatch(authenticationSuccess(token, user_id));
        if (profilePicFormData) {
          dispatch(addProfilePicToUser(token, user_id, profilePicFormData));
        }
        if (newPracticeInfo) {
          return registerCreateNewPractice(newPracticeInfo, token)
        }
        if (existingPracticeInfo) {
          return Promise.all([
            requestToExistingPractice(user_id, existingPracticeInfo.practice_id, token),
            registerPracticeUserRoles(user_id, existingPracticeInfo.practice_id, existingPracticeInfo.user_roles, token)
          ])
        }
      }
    })
    .then((res) => {
      dispatch(signIn(userInfo.email, userInfo.password))
    })
    .catch((error) => { console.log(error) });

  }
}

const signUp = (userInfo, failureCallback, successCallback) => {
  return (dispatch, getState) => {

    let user           = Object.assign({}, userInfo);
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    let request_url    = `${config.BASE_URL}/register_with_code`;

    axios.post(request_url, JSON.stringify(user), request_config).then((response) => {
      let data = response.data;
      if (data.success && data.success === true) {
        dispatch(ToastActions.displayInfo(data.message));
        if (successCallback) {
          successCallback();
        }
      } else {
        dispatch(displayError(null, data))
        failureCallback();
      }
    }).catch((error) => {
      dispatch(displayError(error));
      failureCallback();
    });

  }
}

const registerCreateNewPractice = (data, token) => {

  const requestURL = `${config.BASE_URL}/api/practice`;
  let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

  return axios.post(requestURL, JSON.stringify(data), requestConfig);
}

const requestToExistingPractice = (user_id, practice_id, token) => {
  const requestObject = {
    practice_id: practice_id,
    practice_location_id: 'custom',
    user_id: user_id,
  }
  return fetch(`${config.BASE_URL}/api/practice/join_request`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': token,
    },
    body: JSON.stringify(requestObject)
  })
}

const registerPracticeUserRoles = (user_id, practice_id, user_roles, token) => {
  var roles = Object.assign({}, user_roles);
  roles.user_id = user_id;
  roles.practice_id = practice_id;
  return fetch(`${config.BASE_URL}/api/user/user_roles`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': token,
    },
    body: JSON.stringify(roles)
  })
}

const fetchExistingPractice = (code, callback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/practice_search/${code}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    dispatch({ type: actions.LOADING_SEARCH_PRACTICE_CODE, payload: true });

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.practice) {
        callback(data.practice)
      } else {
        callback(null);
      }
      dispatch({ type: actions.LOADING_SEARCH_PRACTICE_CODE, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_SEARCH_PRACTICE_CODE, payload: false });
      console.log('No Practice Found')
    });

  }
}

const sendJoinRequestToPractice = (user_id, practice, user_roles, token, successCallback) => {
  return dispatch => {

    const requestExistingPracticeObject = {
      practice_id: practice._id,
      practice_location_id: 'custom',
      user_id: user_id,
      user_roles: user_roles,
    }

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestToExistingPracticeURL = `${config.BASE_URL}/api/practice/join_request`;

    axios.post(requestToExistingPracticeURL, JSON.stringify(requestExistingPracticeObject), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getUserRoles(token, user_id))
        if (successCallback) {
          successCallback()
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const addProfilePicToUser = (token, user_id, formData) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/file/profile`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, formData, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {
        const url = data.message.Location;
        const updateObject = {
          _id: user_id,
          photo_url: url,
        }
        dispatch(editUser(token, updateObject))
      }
      if (data.error) { console.log(data.error) }
    }).catch((error) => { console.log(error) });

  }
}

const editUser = (token, user, callBack) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/${user._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    dispatch({ type: actions.LOADING_USER_PROFILE_EDIT, payload: true });

    axios.put(requestURL, JSON.stringify(user), requestConfig).then((response) => {
      var data = response.data || {};
      if (data.success === true) {
        dispatch(getAuthenticatedUserInfo(token, user._id))
        dispatch(ToastActions.displayInfo('Saved Profile Changes!'))
        if (callBack) {
          callBack();
        }
      } else {
        const errorMessage = data.error && data.error.message ? data.error.message : 'Update Error. Please ensure you are connected to the internet';
        if (errorMessage) {
          callBack(errorMessage)
        }
      }
      dispatch({ type: actions.LOADING_USER_PROFILE_EDIT, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_USER_PROFILE_EDIT, payload: false });
      console.log(error)
    });

  }
}

const openEditUser = () => {
  return dispatch => {
    history.push(routes.USER_PROFILE_EDIT);
  }
}

const cancelPracticeJoinRequest = (token, practice_id, user_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/join_request/remove/${practice_id}/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.delete(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getUserRoles(token, user_id));
      }
    }).catch((error) => { console.log(error) });

  }
}

const getUserPracticeLocations = (token, user_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/practice/location/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const locations = data.data || [];
      if (data.success === true) {
        dispatch({ type: actions.PRACTICE_STAFF_MEMBER_SELECTED_LOCATIONS_UPDATE, payload: locations });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getProviderPracticticeLocations = (token, user_id, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/practice/location/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data      = response.data || {};
      const locations = data.data || [];

      if (data.success === true) {
        locations.forEach((location_info) => {
          let location_id      = location_info.practice_location_id;
          let provider_user_id = location_info.user_id;
          if (practice_id === location_info.practice_id) {
            let provider_location_item = {
              location_id: location_id,
              user_id: provider_user_id,
            }
            dispatch({ type: actions.PRACTICE_PROVIDER_LOCATION_DICT_ADD, payload: provider_location_item });
          }
        });
      }
    }).catch((error) => { console.log(error) });

  }
}

const addUserPracticeLocation = (token, location, successCallback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/practice/location`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, JSON.stringify(location), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getUserPracticeLocations(token, location.user_id))
        if (successCallback) {
          successCallback();
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const deleteUserPracticeLocation = (token, user_id, practice_location_id, successCallback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/practice/location/${user_id}/${practice_location_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.delete(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getUserPracticeLocations(token, user_id))
        if (successCallback) {
          successCallback();
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const subToNotifSocket = () => {
  return (dispatch, getState) => {
    const state   = getState();
    const user_id = state.user && state.user.auth && state.user.auth.user_id ? state.user.auth.user_id : '';

    if (user_id) {
      dispatch(NotificationsActions.subscribeToNotificationsSocket(user_id));
    }
  }
}

const changeUserPassword = (token, email, newPassword, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/user/change_password`;
    const postObject = { email: email, password: newPassword };
    dispatch({ type: actions.LOADING_CHANGE_PASSWORD, payload: true });

    axios.post(requestURL, JSON.stringify(postObject), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        if (callBack) {
          callBack();
        }
        dispatch(ToastActions.displayInfo('Password Changed Successfully!'))
      } else {
        dispatch(displayError(null, data))
      }
      dispatch({ type: actions.LOADING_CHANGE_PASSWORD, payload: false });
    }).catch((error) => {
      console.log(error)
      dispatch(displayError(error));
      dispatch({ type: actions.LOADING_CHANGE_PASSWORD, payload: false });
    });

  }
}

const sendForgotPasswordEmail = (email, callback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/password_reset`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.post(requestURL, JSON.stringify({ email: email }), requestConfig).then((response) => {
      const data = response.data || {};

      dispatch(ToastActions.displayInfo('Email Sent!'))

      if (callback) {
        callback();
      }

    }).catch((error) => {
      if (callback) {
        callback();
      }
    })

  }
}

const getUserNotificationPreferences = (token, user_id, updateCallback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/user/notification_preferences/${user_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

      if (data.success) {
        if (data.none_exists) {
          dispatch(addDefaultNotificationPreferences(token, user_id));
        } else {
          if (updateCallback) {
            updateCallback(data.preferences);
          }
          dispatch({ type: actions.USER_NOTIFICATION_PREFERENCES_UPDATE, payload: data.preferences })
        }
      }
    }).catch((error) => { });

  }
}

const addDefaultNotificationPreferences = (token, user_id) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/user/default_notification_preferences`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, JSON.stringify({}), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getUserNotificationPreferences(token, user_id));
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const updateUserNotificationPreferences = (token, notification_preferences) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/notification_preferences/${notification_preferences.user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.put(requestURL, JSON.stringify(notification_preferences), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getUserNotificationPreferences(token, notification_preferences.user_id))
      }
    }).catch((error) => { console.log(error) });

  }
}

const codeSignIn = (email, phone, code, failure_callback) => {
  return dispatch => {

    let post_data      = { email: email, phone: phone, code: code };
    let request_url    = `${config.BASE_URL}/verify_login_code`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.post(request_url, JSON.stringify(post_data), request_config).then((response) => {
      let data = response.data;

      if (data.success) {
        let token   = data.token;
        let user_id = data.user_id;
        dispatch(getAuthenticatedUserInfo(token, user_id, true));
        dispatch(ToastActions.displayInfo('Signed In Successfully!'))
      } else {
        let message = data.message
            message = data.error ? data.error : message;
        if (message) {
          dispatch(ToastActions.displayError(message));
        }
        failure_callback(message);
      }

    }).catch((error) => { console.log(error) });

  }
}

const sendSignInCodeEmail = (email, success_callback, failure_callback) => {
  return dispatch => {

    let post_data      = { email: email };
    let request_url    = `${config.BASE_URL}/send_login_code`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.post(request_url, JSON.stringify(post_data), request_config).then((response) => {
      let data = response.data;

      if (data.success) {
        let password_login = data.passwordLogin;
        success_callback(password_login);
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message))
        }
      } else {
        let message = data.message;
            message = data.error ? data.error : message;
        if (message) {
          dispatch(ToastActions.displayError(message))
        }
        failure_callback();
      }
    }).catch((error) => {
      dispatch("Network Error. Please try again.");
      failure_callback();
      console.log(error)
    });

  }
}

const sendSignInCodeText = (phone_number, success_callback, failure_callback) => {
  return dispatch => {

    let post_data      = { phone: phone_number };
    let request_url    = `${config.BASE_URL}/send_login_code`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.post(request_url, JSON.stringify(post_data), request_config).then((response) => {
      let data = response.data;

      if (data.success) {
        let password_login = data.passwordLogin;
        success_callback(password_login);
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message))
        }
      } else {
        let message = data.message;
            message = data.error ? data.error : message;
        if (message) {
          dispatch(ToastActions.displayError(message))
        }
        failure_callback();
      }
    }).catch((error) => {
      failure_callback();
      dispatch(ToastActions.displayError('Network Error. Please try again or request a new code.'));
      console.log(error)
    });

  }
}

const sendPhoneVerificationCode = (token, phone_number, success_callback, failure_callback) => {
  return dispatch =>  {

    let post_data      = { phone: phone_number };
    let request_url    = `${config.BASE_URL}/api/user/send_phone_verify`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(post_data), request_config).then((response) => {
      let data = response.data;

      if (data.success) {
        let message = data.message;
        success_callback();
        if (message) {
          dispatch(ToastActions.displayInfo(message))
        }
      } else {
        let message = data.message;
            message = data.error ? data.error : message;
        if (message) {
          dispatch(ToastActions.displayError(message))
        }
        failure_callback();
      }
    }).catch((error) => { console.log(error) });

  }
}

const verifyPhoneCode = (token, user_id, phone_number, code, success_callback, failure_callback) => {
  return dispatch =>  {

    let post_data      = { phone: phone_number, code: code };
    let request_url    = `${config.BASE_URL}/api/user/verify_phone_code`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(post_data), request_config).then((response) => {
      let data = response.data;

      if (data.success) {
        let message = data.message;
        dispatch(getAuthenticatedUserInfo(token, user_id))
        success_callback();
        if (message) {
          dispatch(ToastActions.displayInfo(message))
        }
      } else {
        let message = data.message;
            message = data.error ? data.error : message;
        if (message) {
          dispatch(ToastActions.displayError(message))
        }
        failure_callback();
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeJoinInvites = (token, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/invites/get_user_invites`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data    = response.data || {};
      let invites = data.invites  || [];

      if (data.success) {
        callback(invites);
      }
    }).catch((error) => {
      console.log(error)
    });

  }
}


const updateInvite = (token, invite, is_accept, is_initial_fetch, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/invites/accept_decline/${invite._id}/${is_accept}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, {}, request_config).then((response) => {
      const data = response.data || {};
      let fetch  = is_initial_fetch === true ? true : false;
      dispatch(getUserRoles(token, invite.user_id, fetch));
      dispatch(ToastActions.displayInfo(`Invite ${is_accept ? 'Accepted' : 'Declined'} Successfully!`));
      if (callback) {
        callback();
      }
    }).catch((error) => { console.log(error) });

  }
}

const incrementTolstoyDisplayCount = (turn_off) => {
  return (dispatch, getState) => {

    let state = getState();
    let user  = state.user;
    let tolstoy_count = user ? user.diplayedTolstoyCount : 0;

    let new_count = tolstoy_count + 1;

    if (turn_off) {
      new_count = 4;
    }

    dispatch({ type: actions.USER_DISPLAYED_TOLSTOY_COUNT_UPDATE, payload: new_count });

  }
}

export default {
  addUserPracticeLocation,
  authenticationSuccess,
  codeSignIn,
  createAccount,
  changeUserPassword,
  deleteUserPracticeLocation,
  fetchExistingPractice,
  getPractice,
  getUserPracticeLocations,
  getUserNotificationPreferences,
  getProviderPracticticeLocations,
  getPracticeJoinInvites,
  incrementTolstoyDisplayCount,
  openEditUser,
  sendForgotPasswordEmail,
  sendJoinRequestToPractice,
  sendPhoneVerificationCode,
  sendSignInCodeEmail,
  signUp,
  signIn,
  signOut,
  sendSignInCodeText,
  subToNotifSocket,
  editUser,
  cancelPracticeJoinRequest,
  getUserRoles,
  updateUserNotificationPreferences,
  updateInvite,
  verifyPhoneCode,
}
